export function generateSlugFromTitle(title) {
    if (!title || typeof title !== 'string') {
        return 'untitled';
    }
    let slug = title
        .toLowerCase()
        .trim()
        .replace(/[\s_]+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '');
    if (!slug) {
        slug = 'untitled';
    }
    if (slug.length > 50) {
        slug = slug.substring(0, 50).replace(/-+$/, '');
    }
    return slug;
}
export const slugify = generateSlugFromTitle;
export function stripCitationMarkers(text) {
    return text
        .replace(/\s*\[\d+(?:\s*,\s*\d+)*\]/g, '')
        .replace(/[ \t]{2,}/g, ' ');
}
export function stripPerformanceMarkup(text) {
    return text
        .replace(/[ \t]*\|[^|\n]*\|/g, '')
        .replace(/[ \t]*<[a-z][a-z -]*>/gi, '')
        .replace(/[ \t]*\[[^\]\n]*\]/g, '')
        .replace(/[ \t]{2,}/g, ' ')
        .replace(/[ \t]+([,.!?;:])/g, '$1')
        .replace(/^[ \t]+/gm, '');
}
//# sourceMappingURL=string.js.map